var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisualisationComboAction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_17348_100380)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 32,
    height: 32,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17348_100380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3496 6.65039H21.3496V7.40039H30.3496V6.65039Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4365 6.65128L15.3496 13.7969L16.0006 14.1692L20.0875 7.02364L19.4365 6.65128Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.958 16.304L19.3613 24.2734L20.0178 23.9107L15.6144 15.9413L14.958 16.304Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1648 14.1509L31.8496 22.6406L32.5182 22.9805L36.8334 14.4907L36.1648 14.1509Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5718 7.36232L34.3047 14.5234L34.9698 14.1768L31.2368 7.01563L30.5718 7.36232Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8496 14.9004H27.3496V15.6504H34.8496V14.9004Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3496 14.9004H16.8496V15.6504H27.3496V14.9004Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0117 15.4397L21.6963 7.57422L21.0749 7.99416L26.3903 15.8597L27.0117 15.4397Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3331 14.2952L20.1504 23.5586L20.8049 23.9248L25.9876 14.6614L25.3331 14.2952Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2348 14.8926L30.6504 24.4336L31.3026 24.0634L25.887 14.5224L25.2348 14.8926Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0664 14.9575L32.4268 7.52734L31.8185 7.08854L26.4582 14.5187L27.0664 14.9575Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3496 23.1504H21.3496V23.9004H30.3496V23.1504Z",
    fill: "#8F95B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6002 9.8C21.9257 9.8 23.0002 8.72548 23.0002 7.4C23.0002 6.07452 21.9257 5 20.6002 5C19.2747 5 18.2002 6.07452 18.2002 7.4C18.2002 8.72548 19.2747 9.8 20.6002 9.8Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 26.0008C21.7598 26.0008 22.7 25.0606 22.7 23.9008C22.7 22.741 21.7598 21.8008 20.6 21.8008C19.4402 21.8008 18.5 22.741 18.5 23.9008C18.5 25.0606 19.4402 26.0008 20.6 26.0008Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.85 17.7508C27.0098 17.7508 27.95 16.8106 27.95 15.6508C27.95 14.491 27.0098 13.5508 25.85 13.5508C24.6902 13.5508 23.75 14.491 23.75 15.6508C23.75 16.8106 24.6902 17.7508 25.85 17.7508Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1002 9.8C32.4257 9.8 33.5002 8.72548 33.5002 7.4C33.5002 6.07452 32.4257 5 31.1002 5C29.7747 5 28.7002 6.07452 28.7002 7.4C28.7002 8.72548 29.7747 9.8 31.1002 9.8Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1 26.0008C32.2598 26.0008 33.2 25.0606 33.2 23.9008C33.2 22.741 32.2598 21.8008 31.1 21.8008C29.9402 21.8008 29 22.741 29 23.9008C29 25.0606 29.9402 26.0008 31.1 26.0008Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6 17.7508C36.7598 17.7508 37.7 16.8106 37.7 15.6508C37.7 14.491 36.7598 13.5508 35.6 13.5508C34.4402 13.5508 33.5 14.491 33.5 15.6508C33.5 16.8106 34.4402 17.7508 35.6 17.7508Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 17.7508C17.2598 17.7508 18.2 16.8106 18.2 15.6508C18.2 14.491 17.2598 13.5508 16.1 13.5508C14.9402 13.5508 14 14.491 14 15.6508C14 16.8106 14.9402 17.7508 16.1 17.7508Z",
    fill: "#232F6A",
    stroke: "white",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_17348_100380",
    x: -4,
    y: -14,
    width: 60,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_17348_100380"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5525 0 0 0 0 0.56225 0 0 0 0 0.65 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_17348_100380",
    result: "effect2_dropShadow_17348_100380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17348_100380",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17348_100380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(14 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualisationComboAction);
export default __webpack_public_path__ + "static/media/visualisation-combo-action.91cbe60af11b12903bc18819303e60c4.svg";
export { ForwardRef as ReactComponent };